var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitMerge = function SvgGitMerge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.767 2.047a3.717 3.717 0 0 1 .617 7.38 8.75 8.75 0 0 0 2.545 5.64 8.75 8.75 0 0 0 5.64 2.544 3.717 3.717 0 1 1-.006 1.203 9.95 9.95 0 0 1-8.198-5.2v7.734a.6.6 0 1 1-1.199 0V9.43a3.716 3.716 0 0 1 .6-7.384m12.467 13.667a2.518 2.518 0 1 0 .001 5.036 2.518 2.518 0 0 0 0-5.036M5.767 3.246a2.518 2.518 0 1 0 0 5.036 2.518 2.518 0 0 0 0-5.036"
  })));
};
export default SvgGitMerge;